/**
 * Router state that tells the design editor's back link where the coach came from. It rides on the
 * navigation (not the URL), so a shared link still lands on the usual "‹ Prompt Studio".
 */
export interface PromptStudioBackState {
  back?: { to: string; label: string };
}

export function backToPromptState(to: string): PromptStudioBackState {
  return { back: { to, label: "Back to prompt" } };
}
